import { UserRoles, UserRolesSortOrder } from 'common/userRoles/constants/UserRoles'
import { User } from 'common/userRoles/userRolesInterfaces'

export const getCurrentUserRole = ({ is_creator, user_role }: User) =>
  is_creator ? UserRoles.OWNER : user_role

export const sortUsersByUserRole = (users: User[]) => {
  if (!Array.isArray(users) || !users.length) return []

  return [...users].sort((userA, userB) => {
    const aUserRole = getCurrentUserRole(userA)
    const bUserRole = getCurrentUserRole(userB)
    return UserRolesSortOrder[bUserRole] - UserRolesSortOrder[aUserRole]
  })
}
